export const BUSINESS_ENTITY_TYPES = {
  LLP: {
    name: "LLP",
    value: "llp",
  },
  SOLE_TRADER: {
    name: "Sole Trader",
    value: "soleTrader",
  },
  LIMITED: {
    name: "Limited",
    value: "limited",
  },
  PARTNERSHIP: {
    name: "Partnership",
    value: "partnership",
  },
  NOT_REGISTERED: {
    name: "Not Registered",
    value: "notRegistered",
  },
  OTHER: {
    name: "Other",
    value: "other",
  },
} as const;

export const RETAILER_TYPES = {
  BAR: {
    name: "Bar",
    value: "bar",
  },
  RESTAURANT: {
    name: "Restaurant",
    value: "restaurant",
  },
  DISTRIBUTOR: {
    name: "Distributor",
    value: "distributor",
  },
  PUB: {
    name: "Pub",
    value: "pub",
  },
  ONLINE_STORE: {
    name: "Online Store",
    value: "onlineStore",
  },
  TAP_ROOM: {
    name: "Tap Room",
    value: "tapRoom",
  },
  HOTEL: {
    name: "Hotel",
    value: "hotel",
  },
  OFFICE: {
    name: "Office",
    value: "office",
  },
  OFF_LICENSE: {
    name: "Off-license",
    value: "offLicense",
  },
  OTHER: {
    name: "Other",
    value: "other",
  },
} as const;

export const ORDER_FULFILLMENT_TYPES = {
  DIRECT: {
    name: "Direct",
    value: "direct",
  },
  DISTRIBUTION: {
    name: "Sellar Distribution",
    value: "sellarDistribution",
  },
  COURIER: {
    name: "Courier",
    value: "courier",
  },
  HAULIER: {
    name: "Pallet",
    value: "haulier",
  },
  COLLECTION: {
    name: "Collection",
    value: "collection",
  },
  UPS: {
    name: "Courier UPS",
    value: "ups",
  },
  APC: {
    name: "Courier APC",
    value: "apc",
  },
  DX_BASIC: {
    name: "Courier DX",
    value: "dxBasic",
  },
  DX: {
    name: "Courier DX (Collection)",
    value: "dx",
  },
  DX_DROPOFF: {
    name: "Courier DX (Drop Off Point)",
    value: "dxDropOff",
  },
} as const;

export const UPS_WEIGHT_CHANGE_DATE = new Date(
  import.meta.env.VITE_ENV === "production"
    ? "2025-09-30T00:00:00Z" // Production: Real change date
    : "2025-09-23T00:00:00Z", // Development/Staging: earlier date for QA testing
);

export const ORDER_SETTINGS_TYPES = {
  PACKAGING: {
    name: "Packaging",
    value: "packaging",
  },
} as const;

export const ORDER_PAYMENT_TYPES = {
  MANUAL: {
    name: "Offline Terms",
    value: "manual",
  },
  STRIPE: {
    name: "SellarPay Credit",
    value: "stripe",
  },
  CHECKOUT: {
    name: "Checkout",
    value: "checkout",
  },
  CARD_PAYMENT: {
    name: "Card Payment",
    value: "cardPayment",
  },
} as const;

export const CONTAINER_TYPES = {
  KEG: {
    type: "keg",
    name: "Keg",
  },
  CASK: {
    type: "cask",
    name: "Cask",
  },
  CAN: {
    type: "can",
    name: "Can",
  },
  BOTTLE: {
    type: "bottle",
    name: "Bottle",
  },
  GLASSWARE: {
    type: "glassware",
    name: "Glassware",
  },
  BAG: {
    type: "bag",
    name: "Bag",
  },
  POUCH: {
    type: "pouch",
    name: "Pouch",
  },
  BAG_IN_BOX: {
    type: "bagInBox",
    name: "Bag In Box",
  },
  JAR: {
    type: "jar",
    name: "Jar",
  },
  BOX: {
    type: "box",
    name: "Box",
  },
} as const;

export const SELLAR_DISCOUNT_TYPES = {
  PERCENTAGE: {
    name: "Percentage",
    value: "percentage",
    description: "Percentage discount",
  },
  PERPETUAL_FLAT: {
    name: "Flat (per item)",
    value: "perpetual-flat",
    description:
      "Once rules fulfilled, add flat discount value for every valid item",
  },
} as const;

export const SELLAR_BUSINESS_ID = 1;

export const SELLAR_CREDIT_ONBOARDING_SOURCE_VALUE = "sellar-credit-onboarding";
export const SELLAR_CREDIT_ONBOARDING_SOURCE_KEY = "source";
